var ctrlopt = ctrlopt;
var google = google;
var site = site;
var createCalendar = createCalendar;

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var settings = Drupal.settings || {};
  var oab = settings.oab || {};
  var oab_time_override = oab.oab_override_time_format || 0;
  var oab_override_min_format = oab.oab_override_min_format || 0;
  var oab_do_not_display_ordinal_for_date = oab.oab_do_not_display_ordinal_for_date || 0;
  var oab_town_postcode_format = oab.oab_town_postcode_format || '';
  // Hide zero service price for All Region
  var hideZeroServicePrice = $('#appointment-book-container').attr('data-disable-price') || 0;
  var google_search_restrict_name = oab.google_search_restrict_name || 0;

  /* Concrete View */
  apptBook.ConfirmSection = function (container) {
    apptBook.ConfirmSection.superclass.constructor.call(this);
    this.id = 'confirmation';
    this.container = container;
    this.currencySymbol = $('#appointment-book-sections').attr('data-currency-symbol');
    this.servicePicturesDirectory = $('#appointment-book-sections').attr('data-service-pictures-directory') || '/media/export/cms/appointment_booking/reskin/services/';
    this.mobileServiceImgSrcFormat = $('#appointment-book-sections').attr('data-service-picture-mobile') || 'mobile/BB_BOA_Services_sidSERVICEID_mob.jpg';
    this.pcServiceImgSrcFormat = $('#appointment-book-sections').attr('data-service-picture-pc') || 'PC/BB_BOA_Services_sidSERVICEID_pc.jpg';
    this.confContainer = container.find('.confirmation-container');
    this.lessons = this.confContainer.find('.appt-service');
    this.location = this.confContainer.find('.appt-details');
    this.dateTime = this.confContainer.find('.appt-details');
    this.artistName = this.confContainer.find('.artist');
    this.minLabel = this.container.attr('data-minutes-label');
    this.amLabel = this.container.attr('data-am-label');
    this.pmLabel = this.container.attr('data-pm-label');
    this.displayAMPM = this.container.attr('data-am-pm-display');
    this.dateFormat = this.container.attr('data-date-format');
    this.days = this.container.attr('data-day-names').split(',');
    this.months = this.container.attr('data-month-names').split(',');
    this.timeFormatSuffix = this.container.attr('data-time-format-suffix');
    this.totalDuration = 0;
    this.map = null;
    this.mapZoomLevel = 13;
    this.isVirtual = 0;
  };

  ctrlopt.extend(apptBook.ConfirmSection, apptBook.AbstractSection);

  apptBook.ConfirmSection.prototype.onUpdate = function (data) {
    var aPgName = document.title + ' - Confirmation';

    if (data.sectionId === this.id) {
      if (data.params.counter.calendars[0].virtual === '1') {
        this.isVirtual = 1;
      }
      this.confData = data.params;
      this.buildServices(this.confData.services);
      if (!this.isVirtual) {
        this.buildLocation(this.confData.counter);
      }
      this.buildDateTime(this.confData);
      if (!this.isVirtual && typeof google !== 'undefined') {
        this.buildLocationMap(this.confData.counter);
      }
      if (this.isVirtual) {
        this.container.find('.virtual_oab_content').removeClass('hidden');
        var zoomLink = this.confData.virtual_meeting_link ? this.confData.virtual_meeting_link : '';
        var zoomContainer = this.container.find('#zoom-link');

        if (zoomLink) {
          zoomContainer.attr('href', zoomLink);
          zoomContainer.text(zoomLink);
        }
      } else {
        this.container.find('.physical_oab_content').removeClass('hidden');
      }
    }
  };

  apptBook.ConfirmSection.prototype.buildServices = function (services) {
    var serviceData, historyService, me = this,
      serviceName, serviceImage, servicePrice, serviceTotalDuration,
      servicePriceVal,
      price,
      oab_price_decimal = oab.oab_price_decimal,
      oab_currency_position = oab.oab_currency_position;
    // To support multiple services, we must clone the template and then add a copy to the html for each service
    var $serviceTemplate = this.lessons.clone();

    this.lessons.html('');
    this.lessons.removeClass('appt-service');

    for (var i = 0, len = services.length; i < len; i += 1) {
      var $thisServ = $serviceTemplate.clone();

      serviceData = services[i];
      serviceName = serviceData.name;
      servicePrice = serviceData.price;
      if (site.client.isMobile) {
        serviceImage = this.servicePicturesDirectory + this.mobileServiceImgSrcFormat.replace('CONTENTID', serviceData.online_content_id);
      } else {
        serviceImage = this.servicePicturesDirectory + this.pcServiceImgSrcFormat.replace('CONTENTID', serviceData.online_content_id);
      }
      serviceTotalDuration = serviceData.total_duration;

      // Info that AB tool doesn't provide is taken from the cms values maintained in history
      if (history.state && history.state.updateObj && history.state.updateObj.params && history.state.updateObj.params.services) {
        historyService = history.state.updateObj.params.services[i];
        $thisServ.find('.description').text(historyService.serviceDescription);

        if (!serviceName) {
          serviceName = historyService.serviceName;
        }
        if (!servicePrice) {
          servicePrice = historyService.servicePrice;
        }
      }
      $thisServ.find('.name').text(serviceName);
      $thisServ.find('.service-image').attr('src', serviceImage);
      $thisServ.find('.service-image').addClass('lazyload');
      if (servicePrice) {
        servicePriceVal = oab_price_decimal
          ? parseInt(servicePrice).toFixed(oab_price_decimal)
          : servicePrice;
        price = oab_currency_position === 'suffix'
          ? servicePriceVal + ' ' + this.currencySymbol
          : this.currencySymbol + ' ' + servicePriceVal;
        if (parseInt(servicePriceVal) === 0 && hideZeroServicePrice) {
          $thisServ.find('.price').text();
        } else {
          $thisServ.find('.price').text(price);
        }
      }
      $thisServ.find('.duration').text(serviceTotalDuration + ' ' + this.minLabel);
      if (i !== 0) {
        $thisServ.addClass('no-border');
      }
      this.lessons.append($thisServ);
      me.totalDuration += parseInt(serviceTotalDuration);
    }
  };

  apptBook.ConfirmSection.prototype.buildLocation = function (data) {
    var postcodeTownStr = '',
      googleStr = '',
      name = data.name,
      addr1 = data.address1,
      addr2 = data.address2,
      town = data.town,
      postCode = data.postcode,
      phone = data.phone,
      nameNode = this.location.find('.location-name'),
      addrNode = this.location.find('.location-address'),
      addr2Node = this.location.find('.location-address2'),
      postcodeTownNode = this.location.find('.location-postcode-town'),
      phoneNode = this.location.find('.location-phone'),
      getDir = this.location.find('.location-direction-links');

    if (name) {
      nameNode.html(name);
      name = google_search_restrict_name ? '' : name;
      googleStr += name;
    } else {
      nameNode.hide();
    }

    if (addr1) {
      addrNode.html(addr1);
      googleStr += '+' + addr1;
    } else {
      addrNode.hide();
    }

    if (addr2) {
      addr2Node.html(addr2);
      googleStr += '+' + addr2;
    } else {
      addr2Node.hide();
    }

    if (postCode) {
      postcodeTownStr += postcodeTownStr === '' ? postCode : ', ' + postCode;
      googleStr += '+' + postCode;
    }
    if (town) {
      postcodeTownStr += town;
      googleStr += '+' + town;
    }

    // If this formatting string is set, it overrides the default formatting for this displayed string
    if (oab_town_postcode_format) {
      postcodeTownStr = oab_town_postcode_format.replace('[town]', town).replace('[postcode]', postCode);
    }

    if (postcodeTownStr === '') {
      postcodeTownNode.hide();
    } else {
      postcodeTownNode.html(postcodeTownStr);
    }

    if (phone) {
      phoneNode.text(phone);
      phoneNode.text(phone).attr('href', 'tel:' + phone);
    } else {
      phoneNode.hide();
    }

    getDir.attr('href', 'https://www.google.com/maps?daddr=' + encodeURIComponent(googleStr));
  };

  apptBook.ConfirmSection.prototype.buildDateTime = function (data) {
    var m, d, y, h, hMod, hModMin, hMin, minVal, hSuffix, apptDateStr, min,
      dayName,
      apptDate = this.convertTimeString(data.start_time),
      apptEndDate = new Date(apptDate.getTime()),
      me = this,
      oab_time_separator = oab.oab_time_separator || ':';

    me.calContainer = me.container.find('.appt-date-cal');
    me.addCalLink = me.calContainer.find('.add-cal-link');
    me.calLinksCont = me.calContainer.find('.cals-container');
    me.calLinks = me.calContainer.find('.date-time-link');

    // if (me.calContainer.length) {
    var typeClass = this.isVirtual ? '.virtual' : '.physical';
    var addCalDesc = me.calContainer.find('.add-cal-desc' + typeClass).html() || "Your Makeup Appointment is booked! Please arrive ten minutes before your lesson. We're looking forward to seeing you in person.";
    var addr1 = data.counter.address1 || '',
      addCalTitle = me.calContainer.find('.add-cal-title').html() || 'Appointment',
      addr2 = data.counter.address2 || '',
      town = data.counter.town || '',
      postcode = data.counter.postcode || '',
      addressStr = addr1 + ', ',
      virtCalLocation = data.virtual_meeting_link ? data.virtual_meeting_link : '';

    if (addr2) {
      addressStr += addr2 + ', ';
    }
    addressStr += town + ', ' + postcode;
    // }

    if (this.isVirtual && virtCalLocation) {
      if (site.client.isMobile) {
        addressStr = encodeURIComponent(virtCalLocation);
      } else {
        addressStr = virtCalLocation;
      }
    }

    apptEndDate.setTime(apptEndDate.getTime() + parseInt(me.totalDuration) * 60000);

    dayName = this.days[apptDate.getDay()];
    m = this.months[apptDate.getMonth()];
    d = apptDate.getDate();
    h = apptDate.getHours();
    min = apptDate.getMinutes();
    y = apptDate.getFullYear();
    if (this.displayAMPM === '1') {
      hSuffix = h < 12 ? this.amLabel : this.pmLabel;
      hMin = h;
      hMod = (h + 11) % 12 + 1;
      hModMin = hMod;
      if (oab_override_min_format) {
        minVal = min === 0 ? '00' : min;
        hMin = h + ':' + minVal;
        hModMin = hMod + ':' + minVal;
      } else if (!oab_override_min_format && min !== 0) {
        hMin = h + ':' + min;
        hModMin = hMod + ':' + min;
      }
      h = (oab_time_override ? hMin : hModMin) + ' ' + hSuffix;
    } else {
      h = h + oab_time_separator + (min === 0 ? '00' : min) + this.timeFormatSuffix;
    }
    if (!oab_do_not_display_ordinal_for_date) {
      d = getNumberWithOrdinal(d);
    }
    apptDateStr = this.dateFormat.replace(/\bd\b/, d).replace(/\bm\b/, m).replace(/\by\b/, y).replace(/\bdayName\b/, dayName);
    this.dateTime.find('.appt-date').text(apptDateStr);
    this.dateTime.find('.appt-time').text(h);

    if (me.calContainer.length) {
      me.myCalendar = createCalendar({
        data: {
          device_mobile: site.client.isMobile,
          title: addCalTitle, // Event title
          start: new Date(apptDate.getTime()), // Event start date
          duration: me.totalDuration, // Event duration (IN MINUTES)
          end: new Date(apptEndDate.getTime()), // You can also choose to set an end time.
          address: addressStr,
          description: addCalDesc
        }
      });

      me.calLinks.each(function () {
        var $this = $(this);
        var calID = $(this).attr('data-cal');
        var data = $.grep(me.myCalendar, function (el) {
          if (el.calId.toLowerCase() === calID) {
            return el.calHref;
          }
        });
        var dataUri = data[0].calHref;

        createDownloadLink($this, dataUri, calID, 'calendar.ics');
        $this.on('click', function () {
          me.calLinksCont.toggleClass('expanded');
        });

        function createDownloadLink(anchorSelector, dataUri, calID, fileName) {
          var dateUriIE = '';
          var blobObject = null;

          if (window.navigator.msSaveOrOpenBlob && calID !== 'google') {
            dateUriIE = dataUri.split(',')[1];
            dateUriIE = decodeURIComponent(dateUriIE);
            var fileData = [dateUriIE];

            blobObject = new Blob(fileData);
            $(anchorSelector).click(function (e) {
              e.preventDefault();
              window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            });
          } else {
            $(anchorSelector).attr('href', dataUri);
          }
        }
      });
      me.addCalLink.on('click', function () {
        me.calLinksCont.toggleClass('expanded');
      });
    }
  };

  apptBook.ConfirmSection.prototype.buildLocationMap = function (door) {
    var center;
    var mapOptions = {},
      $bookStoreMap = this.container.find('#appt_book_store_map'),
      $bookStoreMapContainer = this.container.find('.js-appt_book_store_map_container'),
      locLat = door.counter_lat,
      locLng = door.counter_lng;

    center = new google.maps.LatLng(locLat, locLng);

    if (this.map) {
      this.map.setCenter(center);
      this.map.setZoom(this.mapZoomLevel);
    } else {
      mapOptions = {
        zoom: this.mapZoomLevel,
        center: center,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: false,
        navigationControl: true,
        mapTypeControl: false,
        scaleControl: false
      };
      $bookStoreMapContainer.show();
      this.map = new google.maps.Map($bookStoreMap[0], mapOptions);
    }
    addMarket(door, this);

    function addMarket(door, me) {
      var map = me.map;
      var latLng = new google.maps.LatLng(door.counter_lat, door.counter_lng);
      var marker = new google.maps.Marker({
        position: latLng,
        map: map,
        door: door,
        me: me
      });

      marker.setZIndex(google.maps.Marker.MAX_ZINDEX - 1);
      door.marker = marker;
    }
  };

  apptBook.ConfirmSection.prototype.convertTimeString = function (tString) {
    var split, dateArray, timeArray, y, m, d, hr, min, sec;

    split = tString.split(' ');
    dateArray = split[0].split('-');
    timeArray = split[1].split(':');

    y = parseInt(dateArray[0], 10);
    m = parseInt(dateArray[1], 10) - 1;
    d = parseInt(dateArray[2], 10);
    hr = parseInt(timeArray[0], 10);
    min = parseInt(timeArray[1], 10);
    sec = parseInt(timeArray[2], 10);

    return new Date(y, m, d, hr, min, sec);
  };

  Drupal.behaviors.apptBookConfirm = {
    attach: function () {
      if (this.attached) {
        return;
      }
      var view = new apptBook.ConfirmSection($('#confirmation'));

      view.setModel(apptBook.sectionModel).startObserving();
    },
    attached: false
  };
})(jQuery);

function getNumberWithOrdinal(dayNumber) {
  var termination = ['th', 'st', 'nd', 'rd'],
    v = dayNumber % 100;

  return dayNumber + (termination[(v - 20) % 10] || termination[v] || termination[0]);
}
